import { useState } from 'react';
import { ChevronDown, Link2, ShieldCheck, Trash2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { GoogleAuthButton } from '@/components/GoogleAuthButton';
import { DeletionPanel, isDeletionBlocking } from '@/components/account/DeletionPanel';
import { LegalLinks } from '@/components/legal/LegalShell';

function LinkedAccounts() {
  const { session } = useAuth();
  const providers = session?.user?.app_metadata?.providers || [];
  const label = { email: 'E-mail et mot de passe', google: 'Google' };
  return (
    <div className="space-y-3" data-testid="linked-accounts">
      <p className="text-sm text-muted-foreground">Méthodes de connexion liées à ce compte :</p>
      <div className="flex flex-wrap gap-2">
        {providers.map((p) => <span key={p} className="rounded-full bg-surface-cardHover px-3 py-1 text-xs text-white" data-testid={`linked-provider-${p}`}>{label[p] || p}</span>)}
      </div>
      {!providers.includes('google') && (
        <div className="max-w-xs"><GoogleAuthButton link next="/account" label="Lier mon compte Google" testId="link-google-button" /></div>
      )}
    </div>
  );
}

function DeleteAccountSettings() {
  const { profile } = useAuth();
  const [open, setOpen] = useState(isDeletionBlocking(profile?.deletion));
  return (
    <div className="rounded-2xl border border-destructive/30 p-4">
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid="account-delete-toggle"
              className="flex w-full items-center justify-between text-left font-semibold text-destructive">
        <span className="flex items-center gap-2"><Trash2 className="h-4 w-4" /> Supprimer mon compte</span>
        <ChevronDown className={`h-4 w-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && <div className="mt-4"><DeletionPanel /></div>}
    </div>
  );
}

export function AccountPrivacySection() {
  return (
    <>
      <section className="card-surface space-y-4 p-6">
        <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-white"><Link2 className="h-5 w-5 text-brand" /> Connexion</h2>
        <LinkedAccounts />
      </section>
      <section className="card-surface space-y-4 p-6" data-testid="account-privacy-section">
        <h2 className="flex items-center gap-2 font-display text-lg font-semibold text-white"><ShieldCheck className="h-5 w-5 text-brand" /> Paramètres</h2>
        <LegalLinks />
        <DeleteAccountSettings />
        <p className="text-xs text-muted-foreground">Détails de la procédure : <Link to="/delete-account" className="text-brand hover:underline">mymusicia.com/delete-account</Link></p>
      </section>
    </>
  );
}
